import { useCallback, useEffect, useState } from 'react';
import { categoriasService, modificadoresService, productosService } from '../../services/api';
import { useConfigNegocio } from '../../hooks/useConfigNegocio';
import { parseCsv, UNIDADES_PRODUCTOS_DEFAULT } from '../../constants/catalogos';
import { useToast } from '../../components/ui/Toast';
import Dialogo from '../../components/ui/Dialogo';
import { btnPrimario, btnSecundario, chip, money } from '../../components/ui/estilos';
import { entrada } from '../agenda/campos';
import EditorProducto from './EditorProducto';

const TODAS = 'todas';

export default function Productos() {
  const cfg = useConfigNegocio();
  const unidades = parseCsv(cfg.productos_unidades, UNIDADES_PRODUCTOS_DEFAULT);
  const [toast, say] = useToast();
  const [productos, setProductos] = useState<any[]>([]);
  const [categorias, setCategorias] = useState<any[]>([]);
  const [grupos, setGrupos] = useState<any[]>([]);
  const [cat, setCat] = useState(TODAS);
  const [busca, setBusca] = useState('');
  const [selId, setSelId] = useState<string | null>(null);
  const [nuevo, setNuevo] = useState<null | 'producto' | 'categoria'>(null);

  const cargar = useCallback(async () => {
    try {
      const [p, c] = await Promise.all([productosService.getAll(), categoriasService.getAll()]);
      setProductos(p.data); setCategorias(c.data);
    } catch { say('No se pudo cargar el menú.'); }
    modificadoresService.getAll().then(r => setGrupos(r.data)).catch(() => {});
  }, [say]);
  useEffect(() => { cargar(); }, [cargar]);

  const q = busca.trim().toLowerCase();
  const visibles = productos.filter(p => (cat === TODAS || p.categoria_id === cat) && (!q || p.nombre.toLowerCase().includes(q) || (p.clave || '').toLowerCase().includes(q)));
  const sel = productos.find(p => p.id === selId) || null;
  const cuenta = (id: string) => productos.filter(p => p.categoria_id === id).length;

  return (
    <div className="paneles" style={{ margin: '-22px -24px', height: 'calc(100% + 44px)', minHeight: 480, display: 'grid', gridTemplateColumns: 'clamp(140px,18%,210px) minmax(240px,1fr) clamp(300px,32%,420px)' }}>
      <nav aria-label="Categorías" style={{ borderRight: '1px solid var(--line)', background: 'var(--surface)', display: 'flex', flexDirection: 'column', minHeight: 0, padding: '16px 10px', gap: 6, overflowY: 'auto' }}>
        <button onClick={() => setNuevo('categoria')} style={{ height: 40, borderRadius: 9, border: '1px dashed var(--line-strong)', background: 'transparent', fontSize: 14, fontWeight: 700, cursor: 'pointer', color: 'var(--brand-texto)' }}>+ Categoría</button>
        {[{ id: TODAS, nombre: 'Todas', n: productos.length }, ...categorias.map(c => ({ id: c.id, nombre: c.nombre, n: cuenta(c.id) }))].map(c => (
          <button key={c.id} onClick={() => setCat(c.id)} aria-current={cat === c.id || undefined} className="nav-item"
            style={{ minHeight: 44, textAlign: 'left', padding: '0 12px', border: 'none', borderRadius: 9, fontSize: 15, fontWeight: 700, cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 6,
              background: cat === c.id ? 'var(--well)' : 'transparent', color: 'var(--ink)' }}>
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.nombre}</span><span style={{ fontSize: 13, color: 'var(--muted)' }}>{c.n}</span>
          </button>
        ))}
      </nav>

      <section aria-label="Productos" style={{ minHeight: 0, overflowY: 'auto', padding: '18px 22px', display: 'flex', flexDirection: 'column', gap: 14 }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center' }}>
          <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar producto o clave…" aria-label="Buscar producto" style={{ ...entrada, flex: 1, minWidth: 200, width: 'auto', borderRadius: 12 }} />
          <button onClick={() => setNuevo('producto')} disabled={!categorias.length} style={{ ...btnPrimario, height: 48, fontSize: 15 }}>+ Producto</button>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
          {!visibles.length && <div style={{ gridColumn: '1/-1', padding: 30, textAlign: 'center', color: 'var(--muted)', fontSize: 15 }}>No hay productos con ese filtro.</div>}
          {visibles.map(p => {
            const on = selId === p.id;
            return (
              <button key={p.id} onClick={() => setSelId(p.id)} aria-pressed={on} style={{
                textAlign: 'left', padding: '14px 16px', borderRadius: 14, cursor: 'pointer', display: 'flex', gap: 12, color: 'var(--ink)',
                border: on ? '2px solid var(--brand-texto)' : '1px solid var(--line)', background: on ? 'var(--well)' : 'var(--surface)', opacity: p.suspendido ? .6 : 1,
              }}>
                {p.imagen && <img src={p.imagen} alt="" style={{ width: 48, height: 48, borderRadius: 10, objectFit: 'cover', flex: 'none' }} />}
                <span style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 6 }}>
                  <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8 }}>
                    <span style={{ fontSize: 16, fontWeight: 700 }}>{p.nombre}</span>
                    <span style={{ fontSize: 15, fontWeight: 700 }}>{p.precio_abierto ? 'Abierto' : money(parseFloat(p.precio))}</span>
                  </span>
                  <span style={{ fontSize: 13, color: 'var(--muted)' }}>{p.categoria}</span>
                  {(p.suspendido || !p.disponible) && (
                    <span style={{ ...chip(p.suspendido ? 'var(--well)' : 'var(--danger-bg)', p.suspendido ? 'var(--muted)' : 'var(--danger)'), fontSize: 12, padding: '2px 8px', alignSelf: 'flex-start' }}>
                      {p.suspendido ? 'Oculto del menú' : 'Agotado'}
                    </span>
                  )}
                </span>
              </button>
            );
          })}
        </div>
      </section>

      <aside aria-label="Editar producto" style={{ borderLeft: '1px solid var(--line)', background: 'var(--surface)', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        {sel
          ? <EditorProducto key={sel.id} producto={sel} categorias={categorias} unidades={unidades} grupos={grupos} say={say} onCambio={cargar} onEliminado={() => { setSelId(null); cargar(); }} />
          : <div style={{ flex: 1, display: 'grid', placeItems: 'center', padding: 24, textAlign: 'center', color: 'var(--muted)', fontSize: 16 }}>Elige un producto para editarlo.</div>}
      </aside>

      {nuevo === 'producto' && <NuevoProducto categorias={categorias} categoria={cat === TODAS ? categorias[0]?.id : cat} iva={cfg.iva_default || '16'} say={say}
        onCerrar={() => setNuevo(null)} onCreado={id => { setNuevo(null); setSelId(id); cargar(); }} />}
      {nuevo === 'categoria' && <NuevaCategoria say={say} onCerrar={() => setNuevo(null)} onCreada={id => { setNuevo(null); setCat(id); cargar(); }} />}
      {toast}
    </div>
  );
}

function NuevoProducto({ categorias, categoria, iva, say, onCerrar, onCreado }: { categorias: any[]; categoria: string; iva: string; say: (m: string) => void; onCerrar: () => void; onCreado: (id: string) => void }) {
  const [f, setF] = useState({ nombre: '', precio: '', categoria_id: categoria });
  const [error, setError] = useState('');
  const crear = async () => {
    if (!f.nombre.trim() || !(parseFloat(f.precio) > 0)) { setError('Captura nombre y un precio mayor a $0.'); return; }
    try {
      const { data } = await productosService.crear({ ...f, nombre: f.nombre.trim(), precio: parseFloat(f.precio), iva: parseFloat(iva), unidad: 'PIEZA', area_impresion: 'COCINA', disponible: true });
      say(`${f.nombre.trim()} agregado al menú.`); onCreado(data.id);
    } catch (e: any) { setError(e.response?.data?.error || 'No se pudo crear el producto.'); }
  };
  return (
    <Dialogo titulo="Nuevo producto" onCerrar={onCerrar} ancho={440}>
      <input autoFocus placeholder="Nombre (ej. Tacos al pastor)" value={f.nombre} onChange={e => setF(x => ({ ...x, nombre: e.target.value }))} maxLength={120} style={entrada} aria-label="Nombre" />
      <input type="number" min="0" inputMode="decimal" placeholder="Precio" value={f.precio} onChange={e => setF(x => ({ ...x, precio: e.target.value }))} style={entrada} aria-label="Precio" />
      <select value={f.categoria_id} onChange={e => setF(x => ({ ...x, categoria_id: e.target.value }))} style={entrada} aria-label="Categoría">
        {categorias.map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
      </select>
      {error && <div role="alert" style={{ color: 'var(--danger)', fontWeight: 700 }}>{error}</div>}
      <div style={{ display: 'flex', gap: 10 }}>
        <button onClick={onCerrar} style={{ ...btnSecundario, flex: 1, height: 52 }}>Cancelar</button>
        <button onClick={crear} style={{ ...btnPrimario, flex: 2, height: 52, fontSize: 16 }}>Crear producto</button>
      </div>
    </Dialogo>
  );
}

function NuevaCategoria({ say, onCerrar, onCreada }: { say: (m: string) => void; onCerrar: () => void; onCreada: (id: string) => void }) {
  const [nombre, setNombre] = useState('');
  const [error, setError] = useState('');
  const crear = async () => {
    if (!nombre.trim()) { setError('Escribe el nombre de la categoría.'); return; }
    try { const { data } = await categoriasService.crear({ nombre: nombre.trim() }); say(`Categoría ${nombre.trim()} creada.`); onCreada(data.id); }
    catch (e: any) { setError(e.response?.data?.error || 'No se pudo crear la categoría.'); }
  };
  return (
    <Dialogo titulo="Nueva categoría" onCerrar={onCerrar} ancho={400}>
      <input autoFocus placeholder="Nombre (ej. Postres)" value={nombre} onChange={e => setNombre(e.target.value)} onKeyDown={e => e.key === 'Enter' && crear()} maxLength={60} style={entrada} aria-label="Nombre de la categoría" />
      {error && <div role="alert" style={{ color: 'var(--danger)', fontWeight: 700 }}>{error}</div>}
      <div style={{ display: 'flex', gap: 10 }}>
        <button onClick={onCerrar} style={{ ...btnSecundario, flex: 1, height: 52 }}>Cancelar</button>
        <button onClick={crear} style={{ ...btnPrimario, flex: 2, height: 52, fontSize: 16 }}>Crear categoría</button>
      </div>
    </Dialogo>
  );
}
